import { useMemo } from "react";
import purify from "dompurify";
import { marked } from "marked";
import PropTypes from "prop-types";

MarkdownDiv.propTypes = {
  markdown: PropTypes.string,
};

export default function MarkdownDiv({ markdown }) {
  const html = useMemo(() => purify.sanitize(marked(markdown)), [markdown]);
  if (!markdown) return null;

  return (
    <div
      className="md-inner-html rt-Text rt-r-size-2"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
